<div *ngIf="!singleSelectedFacility; else elseBlock">
    <my-single-facility-selector
            (selectedSingleFacilityCallback)="onSingleSelectedFacility($event)"
    ></my-single-facility-selector>
</div>
<ng-template #elseBlock>
    <div class="main" id="main">
        <div class="content-area">
            <h1>
                Generate Medication Discharge Summary
            </h1>
            <div [ngSwitch]="screen">
                <div *ngSwitchCase="0"></div>
                <div *ngSwitchCase="1">
                    <div class="">
                        <span class="sub-header">Select Resident: </span>
                        <div>
                            <input type="search" [(ngModel)]="searchText" (ngModelChange)="searchResidents($event)" placeholder="Search" style="width: 330px; margin-bottom: 10px">
                        </div>
                        <div class="resident-content-area">
                            <div *ngIf="!filteredResidents; else haveResidents">
                                <img src="assets/img/loading.gif" height="96" width="96">
                            </div>
                            <ng-template #haveResidents>
                                <div *ngIf="filteredResidents.length">
                                    <div *ngFor="let resident of filteredResidents">
                                        <label class="radio">
                                            <input type="radio" name="residents" [value]="resident.IsSelected" [checked]="resident.IsSelected" (change)="selectResident(resident)">
                                            <span></span>
                                            <span class="checkbox-label">{{resident.Name}}</span>
                                        </label>
                                    </div>
                                </div>
                                <div *ngIf="!filteredResidents.length">
                                   <span>No data to display</span>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
                <div *ngSwitchCase="2">
                    <div>
                        <span class="sub-header">Select Resident's Medication(s): </span>
                        <div>
                            <a (click)="selectAll()">
                                {{selectedMedications && medications && selectedMedications.length != medications.length ? 'Select All' : 'Deselect All'}}
                            </a>
                        </div>
                        <div class="medication-content-area">
                            <my-data-table [def]="medOrdersTableDef"
                                           [rows]="medications"
                                           [selections]="selectedMedications"
                                           [hidePager]="true">
                            </my-data-table>
                        </div>
                    </div>
                </div>
                <div *ngSwitchCase="3">
                    <div class="">
                        <span class="">Number of blank rows to add to the medication list (used to manually add additional medications)</span>
                        <div class="line-content-area">
                            <div *ngFor="let lines of lineOptions">
                                <label class="radio">
                                    <input type="radio" name="residents" [value]="lines.selected" [checked]="lines.selected" (change)="selectLines(lines)">
                                    <span></span>
                                    <span class="checkbox-label">{{lines.label}}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row row-no-margin">
                        <span class="">Print drug monographs for all medications?</span>
                        <div class="monograph-content-area">
                            <div>
                                <label class="radio">
                                    <input type="radio" name="monograph" [(ngModel)]="printMonographs" [value]="false" [checked]="!printMonographs">
                                    <span></span>
                                    <span class="checkbox-label">No</span>
                                </label>
                            </div>
                            <div>
                                <label class="radio">
                                    <input type="radio" name="monograph" [(ngModel)]="printMonographs" [value]="true" [checked]="printMonographs">
                                    <span></span>
                                    <span class="checkbox-label">Yes</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="col-6 text-align-left">
                    <button *ngIf="screen === 1" class="btn btn-primary" (click)="reset()">Cancel</button>
                    <button *ngIf="screen != 1" class="btn btn-primary" (click)="back()">Back</button>
                </div>
                <div class="col-6 text-align-right">
                    <div [ngSwitch]="screen">
                        <button *ngSwitchCase="1" (click)="getMedications()" [disabled]="!selectedResident" class="btn btn-primary">Next: Select Medications</button>
                        <button *ngSwitchCase="2" (click)="pickOptions()" class="btn btn-primary">Next: Add Blank Medication Lines</button>
                        <button *ngSwitchCase="3" (click)="generatePDF()" class="btn btn-primary" [disabled]="!hideSpinner" >
                            <img src="assets/img/loading.gif" height="25" width="25" [hidden]="hideSpinner">Finished: View Med Discharge Summary</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>